import React from "react";

const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show ? "modal d-block" : "modal d-none";

  return (
    <div className={showHideClassName}>
      <div className="modal-container">
        {children}
        <a href='#contact-section' onClick={e => e.preventDefault()} className="modal-close" onClick={handleClose}>
          Ok
        </a>
      </div>
    </div>
  );
};

export default Modal;